import api from 'api';
import { PayrollListSalaryComponentsQueryVariables } from 'api/gql-utils/salaryComponents/types';
import { SalaryComponent } from 'components/SalaryComponents/types';
import { useQuery } from 'react-query';
import queryKeys from '../components/queries';
import { filterSalaryComponents } from '../utils';

type Props = {
  requestParams: PayrollListSalaryComponentsQueryVariables;
  enabled?: boolean;
};

const useSalaryComponentsList = <ComponentType extends SalaryComponent>({
  requestParams,
  enabled,
}: Props) => {
  const {
    isLoading,
    data = [],
    error,
    refetch,
  } = useQuery({
    queryKey: [queryKeys.QUERY_LIST_SALARY_COMPONENTS, requestParams],
    queryFn: () => api.salaryComponents.queries.listSalaryComponents<ComponentType>(requestParams),
    select: (data) => {
      return data?.payrollListSalaryComponents?.data?.salaryComponents || [];
    },
    enabled,
    staleTime: 0,
  });

  const getSalaryComponentById = (id: string) => {
    return data.find((item) => item.id === id);
  };

  const searchSalaryComponents = (ignoreKeys: string[] = []) => {
    return filterSalaryComponents<ComponentType>(data, '', ignoreKeys);
  };

  return {
    isFetchingSalaryComponents: isLoading,
    searchSalaryComponents,
    getSalaryComponentById,
    data,
    error,
    refetch,
  };
};

export default useSalaryComponentsList;
